import {
  CButton,
  CFormTextarea,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import moment from 'moment'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import Logo from '../../../assets/Logo.svg'
import AILogo from '../../../assets/BlueLogo.svg'
import {
  postCensusConvo,
  postMessageCensusConvo,
  setChargeClaimStatus,
  setStatus,
} from 'src/helper/backendHelper'
import { toast } from 'react-toastify'
import './ClaimocitySupportPopUp.scss'
import { setActiveTab } from 'src/redux/messages/messageSlice'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'
import { VISIT_STATUS } from '../../../utils/statusConstants'

const ClaimocitySupportPopup = ({
  visible,
  setVisible,
  activePatient,
  page,
  item,
  refreshCensusTable,
}) => {
  const navigate = useNavigate()
  const [text, setText] = useState('')
  const [id, setId] = useState('')
  const activeTab = useSelector((state) => state.messages?.activeTab)
  const user = useSelector((state) => state.user?.user)
  const dispatch = useDispatch()

  const createCensusConvo = async () => {
    let res = await postCensusConvo(activePatient?.id || activePatient?._id)
    if (res?.status === 'success') {
      setId(res?.conversation_id)
    }
  }

  useEffect(() => {
    if (visible) {
      createCensusConvo()
    }
  }, [activePatient, visible])

  const sendMessage = async () => {
    const currentUserId = user?._id
    let data = {
      message_text: text,
      user_id: currentUserId,
      message_type: 1,
      conversation_id: id,
    }
    let res = await postMessageCensusConvo(id, data)
    if (res?.status === 'success') {
      setText('')
      toast.success('The message has been sent.')
      setVisible(false)
    }
  }

  const sendMessageProviderHold = async () => {
    const currentUserId = user?._id
    let data = {
      message_text: text,
      user_id: currentUserId,
      message_type: 1,
      conversation_id: id,
    }
    let res = await postMessageCensusConvo(id, data)
    if (res?.status === 'success') {
      let data = {
        charge_id: item?.id || item?._id,
        newStatus: '5a1e7d8ff7c5f4ebba3f503c',
        parentStatus: 'Provider Hold',
        parent_assigned_userid: currentUserId,
        status: 'Response Received',
        taskid: item?.references?.task_id,
      }
      let statusRes = await setStatus(data, item?.references?.task_id)
      if (statusRes?.status === 'success') {
        let chargeData = {
          charge_ids: [item?.id],
          newStatus: VISIT_STATUS.bill_submitted,
        }
        let chargeClaimStatus = await setChargeClaimStatus(chargeData)
        if (chargeClaimStatus?.status === 'success') {
          await refreshCensusTable()
          setText('')
          toast.success('The message has been sent.')
          setVisible(false)
        }
      }
    }
  }

  const goToMessagePage = async () => {
    let obj = JSON.parse(JSON?.stringify(activeTab))
    obj.selected = 'Provider Hold'
    await dispatch(setActiveTab({ ...obj }))
    navigate('/messages')
    setVisible(false)
  }

  const handleClose = () => {
    setVisible(false)
    setText('')
  }

  return (
    <CModal visible={visible} onClose={handleClose} className="claimocity-support-modal">
      <CModalHeader>
        <CModalTitle>
          <img src={getIsAi() ? AILogo : Logo} alt="Claimocity Logo" />
          Claimocity Billing
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <span>
          {activePatient?.patient_name}{' '}
          {`(${moment(activePatient?.patient_dob)?.format('MM/DD/YYYY')})`}
        </span>
        <br />
        <CFormTextarea
          rows={7}
          className="form-text-area"
          onChange={(e) => setText(e.target.value)}
        />
      </CModalBody>
      <CModalFooter>
        <CButton
          color="secondary"
          onClick={() => {
            goToMessagePage()
          }}
          className="go-to-msg"
        >
          Go to messages
        </CButton>
        <CButton
          color="primary"
          className="send-msg"
          disabled={text?.trim()?.length == 0}
          onClick={() => {
            if (page == 'Provider Hold') {
              sendMessageProviderHold()
            } else {
              sendMessage()
            }
          }}
        >
          Send message
        </CButton>
      </CModalFooter>
    </CModal>
  )
}

export default ClaimocitySupportPopup
